<template>
  <div class="fab" @click="clickEvent">
    <i class="adx-ic_plus"></i>
  </div>
</template>

<script>
export default {
  name: 'adx-fab',
  methods: {
    clickEvent() {
      this.$emit('clicked')
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>